module.exports = __webpack_public_path__ + "static/media/agriculture.8f81fe8b.jpg";